








































































import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { Recorrido } from '@/api/schema'

@Component({})
export default class RecorridosResultList extends Vue {
  @Prop()
  public results!: Recorrido[]
  @Prop()
  public selectedIndex: number
  @Prop()
  public small: boolean

  public directionRight = true

  public iconFromType = (type: string) =>
    ({
      'train': 'train',
      'subway': 'subway',
      'monorail': 'tram',
      'tram': 'tram',
      'light_rail': 'tram',
      'bus': 'directions_bus',
      'trolleybus': 'directions_bus',
      null: 'directions_bus'
    } as any)[type]

  public toggleSmallResults() {
    this.$store.dispatch('toggleSmallResults')
  }

  public getNextPage() {
    ;(this as any).$ga.event('resultados', 'more', '', this.results.length / 5)
    this.$store.dispatch('getNextPage')
  }

  get resultsLoading() {
    return this.$store.getters.getRecorridosLoading
  }

  get resultsMoreLoading() {
    return this.$store.getters.getResultsMoreLoading
  }

  get resultsMore() {
    return this.$store.getters.getResultsMore
  }

  get hasNextResult() {
    return this.$store.getters.hasNextResult
  }

  get hasPrevResult() {
    return this.$store.getters.hasPrevResult
  }

  get transbordo() {
    return this.$store.getters.transbordo
  }

  public nextResult() {
    ;(this as any).$ga.event('resultados', 'next', '', this.selectedIndex)
    this.$emit('update:selectedIndex', this.selectedIndex + 1)
    this.directionRight = true
  }
  public prevResult() {
    ;(this as any).$ga.event('resultados', 'prev', '', this.selectedIndex)
    this.$emit('update:selectedIndex', this.selectedIndex - 1)
    this.directionRight = false
  }
}
